import React from "react";
import { Users } from "lucide-react";

/* Filtro rapido per committente, indipendente per ogni workspace. */
export const ClientFilter = ({ value, onChange, options, testId, label = "Committente" }) => <label className="client-filter">
  {label}
  <span className="client-filter-field">
    <Users size={14} />
    <select data-testid={testId} value={value} onChange={e => onChange(e.target.value)}>
      <option value="">Tutti</option>
      {options.map(name => <option key={name} value={name}>{name}</option>)}
    </select>
  </span>
</label>;

export const clientOptions = names => [...new Set(names.filter(Boolean).map(name => String(name).trim()))]
  .sort((a, b) => a.localeCompare(b, "it", { sensitivity: "base" }));
